// ============================================================
// AssistantBar-Engine — globale, shell-agnostische Voice-UI-Handler.
// 1:1 aus mountAssistantBar (AssistantBar.js) hierher verschoben.
// ============================================================
import { onUiCommand } from '../../../core/uiCommands.ts';
// @ts-expect-error — core/voiceTargets.js ist reines JS ohne Typen
import { installTapTargetHandler } from '../../../core/voiceTargets.js';

let installed = false;

// ── SCROLL (Voice, shell-agnostisch): scrollt den scrollbaren Container
// unter der Bildschirmmitte (mobil .lm-screen, Desktop Hauptbereich/Fenster).
// Hier registriert statt pro Shell, weil die Geste ueberall gleich ist.
// TAP_TARGET (generisches Antippen markierter Elemente) — wie SCROLL
// shell-agnostisch, deshalb hier und nicht pro Shell (core/voiceTargets.js).
export function installAssistantGlobalUiHandlers(): void {
  if (installed) return; // wie früher: nur einmal (mounted-Guard in mountAssistantBar)
  installed = true;

  installTapTargetHandler();

  onUiCommand('SCROLL', (cmd) => {
    const scrollable = (el: Element | null): boolean => {
      if (!el || el === document.body || el === document.documentElement) return false;
      if (el.scrollHeight <= el.clientHeight + 4) return false;
      const oy = getComputedStyle(el).overflowY;
      return oy === 'auto' || oy === 'scroll';
    };
    let el: Element | null = document.elementFromPoint(window.innerWidth / 2, window.innerHeight / 2);
    while (el && !scrollable(el)) el = el.parentElement;
    const target = (el || document.scrollingElement || document.documentElement) as Element;
    const page = target.clientHeight * 0.8;
    const top = cmd.direction === 'top' ? 0
      : cmd.direction === 'bottom' ? target.scrollHeight
      : target.scrollTop + (cmd.direction === 'up' ? -page : page);
    target.scrollTo({ top, behavior: 'smooth' });
    return true;
  });
}
